import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import logoImage from '../../assets/logo/YLHlogo-1.png';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: '2-10 Warranty', href: '/warranty' },
    { 
      name: 'Neighborhoods', 
      href: '/neighborhoods',
      submenu: [
        { name: 'The Highlands – Rome, GA', href: '/neighborhoods/highlands' },
        { name: 'Castleberry Ridge – Dawsonville, GA', href: '/neighborhoods/castleberry' },
      ] 
    },
    { name: 'Our Homes', href: '/homes' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="bg-white shadow-md relative z-20">
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src={logoImage} alt="Yeremian Lifestyle Homes" className="h-20" />
          </Link>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex lg:items-center">
            <ul className="flex space-x-8">
              {navigation.map((item) => (
                <li key={item.name} className="relative group">
                  <Link 
                    to={item.href} 
                    className="font-medium text-dark hover:text-primary transition"
                  >
                    {item.name}
                  </Link>
                  
                  {item.submenu && (
                    <div 
                      className="absolute left-0 mt-2 w-72 bg-white shadow-lg rounded-md py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50"
                      style={{ transitionDelay: '50ms' }}
                    >
                      {item.submenu.map((subitem) => (
                        <Link
                          key={subitem.name}
                          to={subitem.href}
                          className="block px-4 py-2 text-sm text-dark hover:bg-primary/10 hover:text-primary"
                        >
                          {subitem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
            <Link 
              to="/contact" 
              className="ml-8 btn btn-primary"
            >
              Contact Us
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-primary hover:bg-gray-100"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <XMarkIcon className="h-6 w-6" />
            ) : (
              <Bars3Icon className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`lg:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white shadow-lg absolute w-full z-50">
          {navigation.map((item) => (
            <React.Fragment key={item.name}>
              <Link
                to={item.href}
                className="block px-3 py-2 rounded-md text-base font-medium text-dark hover:bg-primary/10 hover:text-primary"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
              
              {item.submenu && (
                <div className="pl-4 space-y-1">
                  {item.submenu.map((subitem) => (
                    <Link
                      key={subitem.name}
                      to={subitem.href}
                      className="block px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:bg-primary/10 hover:text-primary"
                      onClick={() => setIsOpen(false)}
                    >
                      {subitem.name}
                    </Link>
                  ))}
                </div>
              )}
            </React.Fragment>
          ))}
          <Link 
            to="/contact" 
            className="block px-3 py-2 rounded-md text-base font-medium text-white bg-primary hover:bg-primary/90"
            onClick={() => setIsOpen(false)}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 